import React from 'react';
import { ChartFieldSection } from '../../../Layout';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { createMessagesGetter } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';

interface IAtterbergLimitChartSectionProps extends IWorksheetComponent {
  height?: number;
  wide?: boolean;
  visible?: boolean;
}

let AtterbergLimitChartSection: React.FC<IAtterbergLimitChartSectionProps> = ({
  wide = false,
  visible = true,
  height,
  createWorksheetSelector,
}) => {
  const chart = useSelector(createWorksheetSelector!('Chart'));
  const chartMessages = useSelector(
    pipe(createWorksheetSelector!('Messages'), createMessagesGetter('Chart')),
    deepEquals
  );

  return !visible || chart === null ? null : (
    <ChartFieldSection
      wide={wide}
      chart={chart}
      height={height}
      messages={chartMessages?.map((m: any) => ({ message: m.Text, severity: m.MessageType.toLowerCase() }))}
    />
  );
};
AtterbergLimitChartSection = withInjectedProps(AtterbergLimitChartSection);

export { AtterbergLimitChartSection };
export default AtterbergLimitChartSection;
